import InternalApplicationException from "./exceptions/InternalApplicationException";
import ApplicationException from "./exceptions/ApplicationException";
import UnProcessableEntityException from "./exceptions/UnProcessableEntityException";
import FormValidationException from "./exceptions/FormValidationException";
import AuthenticationException from "./exceptions/AuthenticationException";

import config from "./config";

export default (err, vm) => {
    if(config.mode !== 'production'){
        console.log(err);
    }
    if(err instanceof ApplicationException){
        err.errors.forEach(item => {
            vm.$notify({
                group: 'formGroup',
                type : 'error',
                title: vm.$t(item.name),
                text: item.message
            });
        })
    }
    else if(err instanceof InternalApplicationException){
        vm.$notify({
            group: 'formGroup',
            type : 'error',
            title: vm.$t('internal_application_error'),
            text: err.message
        });
    }
    else if(err instanceof UnProcessableEntityException){
        err.errors.forEach(item => {
            vm.$notify({
                group: 'formGroup',
                type : 'error',
                title: vm.$t('messages.validation_error') + ' ' + vm.$t(item.name),
                text: item.message
            });
        })

    }else if(err instanceof FormValidationException){
        vm.$notify({
            group: 'formGroup',
            type : 'error',
            title: 'خطای فرم اطلاعات',
            text: 'لطفاْ فیلد های مورد نیاز را به صورت صحیح وارد نمایید'
        });

    }else if(err instanceof AuthenticationException){
        vm.$notify({
            group: 'formGroup',
            type : 'error',
            title: 'خطای احراز هویت',
            text: 'احراز هویت شما مورد تایید نمی باشد، لطفاً مجدد وارد شود.'
        });
        vm.$router.push({
            name : 'Login'
        })

    }else{
        vm.$notify({
            group: 'formGroup',
            type : 'error',
            title: 'خطا',
            text: 'خطایی رخ داده است'
        });
    }
}